import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import Scope from "@app/types/dashboard/Scope";

// Normalises Scope into the { userId } | { teamId } | {} shape used by all
const scopeToFilter = (scope: Scope): { teamId?: Team["id"]; userId?: User["id"] } =>
  scope.userId ? { userId: scope.userId } : scope.teamId ? { teamId: scope.teamId } : {};

export default scopeToFilter;
